angular.defaults = (obj, defaults) ->
  angular.extend(angular.copy(defaults), obj)
